import * as MUI from "@mui/material";
import { DadosPessoaisProps } from "../types/mandado-facial.types";

export const DadosPessoais: React.FC<DadosPessoaisProps> = ({ pessoa }) => {
  return (
    <MUI.Box>
      <MUI.Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        👤 Dados Pessoais
      </MUI.Typography>

      <MUI.Stack spacing={2}>
        <MUI.Box>
          <MUI.Typography variant="body2" color="text.secondary">
            Nome:
          </MUI.Typography>
          <MUI.Typography variant="body1" fontWeight="bold">
            {pessoa.nome}
          </MUI.Typography>
        </MUI.Box>

        <MUI.Box>
          <MUI.Typography variant="body2" color="text.secondary">
            Nome da Mãe:
          </MUI.Typography>
          <MUI.Typography variant="body1">{pessoa.mae}</MUI.Typography>
        </MUI.Box>

        <MUI.Box>
          <MUI.Typography variant="body2" color="text.secondary">
            Nome do Pai:
          </MUI.Typography>
          <MUI.Typography variant="body1">{pessoa.pai}</MUI.Typography>
        </MUI.Box>

        <MUI.Box>
          <MUI.Typography variant="body2" color="text.secondary">
            Data de Nascimento:
          </MUI.Typography>
          <MUI.Typography variant="body1">
            {pessoa.dataNascimento}
          </MUI.Typography>
        </MUI.Box>
      </MUI.Stack>
    </MUI.Box>
  );
};
